import React from 'react';

export default function StrongIcon(){
  return (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5881 3.71344C11.7673 3.71344 11.0786 3.16982 10.8433 2.42643C10.5243 2.69327 10.1191 2.86075 9.67128 2.86075C8.94527 2.86075 8.32216 2.43352 8.02409 1.82071C7.89032 1.94171 7.73667 2.04603 7.5635 2.12765C7.30376 2.24971 7.02485 2.30933 6.74914 2.30933C6.46988 2.30933 6.19558 2.24226 5.94435 2.12268C5.66296 2.54707 5.25418 2.88666 4.75101 3.04172C5.46886 3.70812 5.91242 4.79678 5.91242 6.06677C5.91242 6.27648 5.74244 6.4461 5.53309 6.4461C5.32373 6.4461 5.15376 6.27613 5.15376 6.06677C5.15376 4.5303 4.40965 3.3295 3.34157 3.13434H2.46475C2.25503 3.13434 2.08542 2.96437 2.08542 2.75501C2.08542 2.54565 2.25539 2.37604 2.46475 2.37604H4.14671C5.10053 2.37604 5.60867 1.4357 5.60867 0.756883C5.60867 0.525524 5.55083 0.326456 5.44579 0.196583C5.33828 0.0645813 5.18179 0 4.96534 0H0.665688C0.328941 0 0 0.09155 0 1.18731V5.19066C0 7.68947 0.74056 8.98998 2.93492 10.3444C3.04669 10.4133 3.11518 10.5357 3.11518 10.667V12.3213C3.11518 12.5306 3.28479 12.7006 3.49451 12.7006H10.3859C10.5956 12.7006 10.7653 12.5306 10.7653 12.3213V10.667C10.7653 10.5516 10.8178 10.4424 10.9083 10.3703C12.8159 8.85017 13.6661 7.25266 13.6661 5.19031V3.35612C13.3627 3.57825 12.9923 3.71344 12.5881 3.71344Z"
        fill="#717BBC"
      />
    </svg>
  );
}